const doc = [({"da":({"js":({"nemoa":({"activities":({"nav":({"index":({"activities":"Aktiviteter", "offers":"Tilbud", "mine":"Mine"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;